import { AnyAction } from 'redux';
import { ActionTypes } from '../../constants/ActionTypes';
import { IReceiverModel, IreceiversOrg } from '../../interfaces';
import {
  ILetterReferFields,
  ILetterReferSendType,
  ILetterReferType,
} from '../../interfaces/Assign';
export interface IAssignState {
  success: boolean;
  assignDetail: any;
  letterReferTypes: ILetterReferType[];
  letterReferSendTypes: ILetterReferSendType[];
  replyReceiversList: [];
  code?: string;
  id?: string;
  personCode?: string;
  isConfidential?: boolean;
}
export interface ILetterDetailFields {
  fields: ILetterReferFields;
}
const INIT_STATE = {
  success: false,
  assignDetail: {
    list: [],
    newRefer: false,
    urgency: [],
    addSpeech: false,
    addPerson: false,
    addsubject: false,
    start: 0,
    receivers: [],
    fields: {
      bodyPenContent: [
        {
          content: '',
          pageNumber: 0,
        },
      ],
      stayInInbox: true,
      followUp: false,
      ignoreReceiverDuplicate: true,
      ignoreReceiverDisabled: true,
      letterCodes: [],
      uploadTaskId: '',
      letterRefers: [
        {
          rowNumber: null,
          receivers: [],
          referText: '',
          letterReferSendTypeId: 0, // GetLetterReferSendTypes!
          referCopyType: 'Original', //None = 0,Original = 1,Copy = 2, BlindCarbonCopy = 3
          letterReferTypeId: null, // GetLetterReferTypes
          isConfidential: false,
          sendSms: false,
          sendEmail: false,
          hideAttachment: false,
          answerDate: null,
          sendSmsIfNoAnswer: false,
          inputType: 'Text', //Text = 0,Html = 1,Pen = 2
          referPenContent: null,
          breakPreviousRefer: false,
          availabilityDeadline: null,
          groupId: null,
          voicePath: '',
          referAttachments: null,
        },
      ],
    },
  },
  letterReferTypes: [],
  letterReferSendTypes: [],
  replyReceiversList: [],
} as IAssignState;

export default (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case ActionTypes.CLEAR_ASSIGN_DETAILS_STATE: {
      const { assignDetail } = state as IAssignState;

      assignDetail.receivers = [];
      assignDetail.fields.letterRefers[0].receivers = [];
      state.replyReceiversList = [];

      return {
        ...state,
      };
    }
    case ActionTypes.GET_REFER_DETAILS: {
      const { assignDetail } = state as IAssignState;
      assignDetail.fields.letterRefers[0].receivers = [];
      assignDetail.receivers = [];

      state.replyReceiversList = [];

      return {
        ...state,
      };
    }

    //Clear State
    case ActionTypes.GET_RECEIVERS_FOR_REPLY: {
      const { assignDetail } = state as IAssignState;

      assignDetail.fields.letterRefers[0].receivers = [];
      assignDetail.receivers = [];

      return {
        ...state,
        success: false,
      };
    }

    // Load New Data
    case ActionTypes.FETCH_RECEIVERS_FOR_REPLY_SUCCESS: {
      const assignDetail = state.assignDetail as ILetterDetailFields;

      action.payload.map((item: AnyAction) => {
        const value: IReceiverModel = {
          id: item.id || item.code || item.personCode,
          text: item.text || item.name,
          sendSms: false,
          isConfidential: false,
          sendEmail: false,
          realName: item.text || item.name,
          referText: null,
          letterReferTypeId: null,
          referAnswerDate: null,
          answerDateTime: null,
          letterReferSendTypeId: null,
          availabilityDeadline: null,
          answerDate: null,
          answerTime: null,
          Type: 0,
          Order: 0,
        };

        let compare: IReceiverModel[];
        // compare = assignDetail.receivers.filter((exist: any) => exist.personCode === value.id)
        compare = assignDetail.fields.letterRefers[0].receivers.filter(
          (exist: IReceiverModel) => exist.personCode === value.id,
        );

        if (compare.length === 0) {
          compare = assignDetail.fields.letterRefers[0].receivers.filter(
            (exist: IReceiverModel) => exist.code === value.id,
          );
          // compare = assignDetail.receivers.filter((exist: any) => exist.code === value.id)
          if (compare.length === 0)
            compare = assignDetail.fields.letterRefers[0].receivers.filter(
              (exist: IReceiverModel) => exist.id === value.id,
            );
          // compare = assignDetail.receivers.filter((exist: any) => exist.id === value.id)
        }

        if (compare.length <= 0) {
          assignDetail.fields.letterRefers[0].receivers.push(value);
          // assignDetail.receivers.push(value);
        }
      });

      return {
        ...state,
        success: true,
      };
    }

    case ActionTypes.GET_LETTER_REFER_TYPES: {
      return {
        ...state,
      };
    }

    case ActionTypes.FETCH_LETTER_REFER_TYPES_SUCCESS: {
      return {
        ...state,
        letterReferTypes: action.payload,
      };
    }

    case ActionTypes.GET_LETTER_REFER_SEND_TYPES: {
      return {
        // letterCode: action.payload,
        ...state,
      };
    }

    case ActionTypes.FETCH_LETTER_REFER_SEND_TYPES_SUCCESS: {
      return {
        ...state,
        letterReferSendTypes: action.payload,
      };
    }

    case ActionTypes.CHANGE_ASSIGN_STATE_ITEMS_VALUE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };

      const { assignDetail } = state as IAssignState;
      const itemKey = action.payload.key;
      const value = action.payload.value;
      assignDetail[itemKey] = value;

      return {
        ...state,
      };
    }

    case ActionTypes.CHANGE_ASSIGN_STATE_FILEDS_ITEMS_VALUE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };
      const { assignDetail } = state as IAssignState;
      const itemKey = action.payload.key;
      const value = action.payload.value;
      assignDetail.fields[itemKey] = value;
      return {
        ...state,
      };
    }

    case ActionTypes.CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };
      const { assignDetail } = state as IAssignState;
      const arrayIndex = action.payload.index;
      // let letterRefersClone = assignDetail.fields.letterRefers[0];
      while (assignDetail.fields.letterRefers[arrayIndex] === undefined) {
        assignDetail.fields.letterRefers.push({
          rowNumber: null,
          receivers: [],
          referText: '',
          letterReferSendTypeId: 0, // GetLetterReferSendTypes!
          referCopyType: 'Original', //None = 0,Original = 1,Copy = 2, BlindCarbonCopy = 3
          letterReferTypeId: null, // GetLetterReferTypes
          isConfidential: false,
          sendSms: false,
          sendEmail: false,
          hideAttachment: false,
          answerDate: null,
          sendSmsIfNoAnswer: false,
          inputType: 'Text', //Text = 0,Html = 1,Pen = 2
          referPenContent: null,
          breakPreviousRefer: false,
          availabilityDeadline: null,
          groupId: null,
          voicePath: '',
          referAttachments: null,
        });
      }

      const itemKey = action.payload.key;
      const value = action.payload.value;
      assignDetail.fields.letterRefers[arrayIndex][itemKey] = value;
      return {
        ...state,
      };
    }

    case ActionTypes.CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE_WITH_TYPE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };

      const { assignDetail } = state as any;
      const itemKey = action.payload.key;
      const arrayIndex = action.payload.index;
      while (assignDetail.fields.letterRefers[arrayIndex] === undefined) {
        assignDetail.fields.letterRefers.push({
          rowNumber: null,
          receivers: [],
          referText: '',
          letterReferSendTypeId: 0, // GetLetterReferSendTypes!
          referCopyType: 'Original', //None = 0,Original = 1,Copy = 2, BlindCarbonCopy = 3
          letterReferTypeId: null, // GetLetterReferTypes
          isConfidential: false,
          sendSms: false,
          sendEmail: false,
          hideAttachment: false,
          answerDate: null,
          sendSmsIfNoAnswer: false,
          inputType: 'Text', //Text = 0,Html = 1,Pen = 2
          referPenContent: null,
          breakPreviousRefer: false,
          availabilityDeadline: null,
          groupId: null,
          voicePath: '',
          referAttachments: null,
        });
      }

      const value: IreceiversOrg = {
        id:
          action.payload.value.id ||
          action.payload.value.code ||
          action.payload.value.personCode,
        text: action.payload.value.text || action.payload.value.name,
        // referText:null,
        // letterReferTypeId:null,
        // referAnswerDate:null,
        // answerDateTime:null,
        sendSms: false,
        isConfidential: false,
        // letterReferSendTypeId: null,
        // availabilityDeadline: null,
        sendEmail: false,
        realName: action.payload.value.text || action.payload.value.name,
        // answerDate: null,
        // answerTime: null,
        type: 2,
      };

      const doType = action.payload.type;
      if (doType === 'ADD') {
        let compare: IAssignState[];
        compare = assignDetail.fields.letterRefers[arrayIndex][itemKey].filter(
          (item: IAssignState) => item.personCode === value.id,
        );
        if (compare.length === 0) {
          compare = assignDetail.fields.letterRefers[arrayIndex][
            itemKey
          ].filter((item: IAssignState) => item.code === value.id);
          if (compare.length === 0)
            compare = assignDetail.fields.letterRefers[arrayIndex][
              itemKey
            ].filter((item: IAssignState) => item.id === value.id);
        }
        if (compare.length <= 0) {
          assignDetail.fields.letterRefers[arrayIndex][itemKey].push(value);
        }
      } else if (doType === 'DEL') {
        assignDetail.fields.letterRefers[arrayIndex][itemKey] =
          assignDetail.fields.letterRefers[arrayIndex][itemKey].filter(
            (item: IAssignState) => item.personCode !== value.id,
          );
        assignDetail.fields.letterRefers[arrayIndex][itemKey] =
          assignDetail.fields.letterRefers[arrayIndex][itemKey].filter(
            (item: IAssignState) => item.code !== value.id,
          );
        assignDetail.fields.letterRefers[arrayIndex][itemKey] =
          assignDetail.fields.letterRefers[arrayIndex][itemKey].filter(
            (item: IAssignState) => item.id !== value.id,
          );
      }

      return {
        ...state,
      };
    }
    case ActionTypes.CHANGE_ASSIGN_STATE_ITEMS_VALUE_WITH_TYPE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };

      const { assignDetail } = state as IAssignState;
      const itemKey = action.payload.key;

      const value: IreceiversOrg = {
        id:
          action.payload.value.id ||
          action.payload.value.code ||
          action.payload.value.personCode,
        text: action.payload.value.text || action.payload.value.name,
        sendSms: false,
        isConfidential: false,
        sendEmail: false,
        realName: action.payload.value.text || action.payload.value.name,
        type: 2,
      };

      const doType = action.payload.type;
      if (doType === 'ADD') {
        let compare: IAssignState[];
        compare = assignDetail[itemKey].filter(
          (item: IAssignState) => item.personCode === value.id,
        );
        if (compare.length === 0) {
          compare = assignDetail[itemKey].filter(
            (item: IAssignState) => item.code === value.id,
          );
          if (compare.length === 0)
            compare = assignDetail[itemKey].filter(
              (item: IAssignState) => item.id === value.id,
            );
        }
        if (compare.length <= 0) {
          assignDetail[itemKey].push(value);
        }
      } else if (doType === 'DEL') {
        assignDetail[itemKey] = assignDetail[itemKey].filter(
          (item: IAssignState) => item.personCode !== value.id,
        );
        assignDetail[itemKey] = assignDetail[itemKey].filter(
          (item: IAssignState) => item.code !== value.id,
        );
        assignDetail[itemKey] = assignDetail[itemKey].filter(
          (item: IAssignState) => item.id !== value.id,
        );
      }

      return {
        ...state,
      };
    }

    case ActionTypes.SEND_REFER_SUCCESS: {
      // let { letterRefers } = state.assignDetail.fields;
      const s = { ...state };
      s.assignDetail.fields.letterRefers = [
        {
          rowNumber: null,
          receivers: [],
          referText: '',
          letterReferSendTypeId: 0, // GetLetterReferSendTypes!
          referCopyType: 'Original', //None = 0,Original = 1,Copy = 2, BlindCarbonCopy = 3
          letterReferTypeId: null, // GetLetterReferTypes
          isConfidential: false,
          sendSms: false,
          sendEmail: false,
          hideAttachment: false,
          answerDate: null,
          sendSmsIfNoAnswer: false,
          inputType: 'Text', //Text = 0,Html = 1,Pen = 2
          referPenContent: null,
          breakPreviousRefer: false,
          availabilityDeadline: null,
          groupId: null,
          voicePath: '',
          referAttachments: null,
        },
      ];

      return {
        ...s,
      };
    }

    case ActionTypes.FAST_REFER: {
      return {
        ...state,
      };
    }

    case ActionTypes.FAST_REFER_SUCCESS: {
      return {
        ...state,
        success: action.payload,
      };
    }
    case ActionTypes.ON_ASSIGN_BODY_LETTER_REFER_ARRAY_ITEM: {
      const { assignDetail } = state as IAssignState;
      const arrayIndex = action.payload;

      // let newLetterRefers = assignDetail.fields.letterRefers.filter((item: any) => item)
      const newLetterRefers = assignDetail.fields.letterRefers.filter(
        (_: number, i: number) => i !== arrayIndex,
      );
      assignDetail.fields.letterRefers = newLetterRefers;

      return {
        ...state,
        letterRefers: newLetterRefers,
      };
    }
    //  UPLOAD REFER FILE
    case ActionTypes.UPLOAD_REFER_FILE: {
      return {
        ...state,
        params: action.payload,
      };
    }
    case ActionTypes.REMOVE_REFER_FILE: {
      return {
        ...state,
        params: action.payload,
      };
    }

    default:
      return state;
  }
};
